import { createFileRoute } from '@tanstack/react-router'
import { RbacPanel } from '@/pages/admin/SystemTab'

export const Route = createFileRoute('/_authenticated/admin/system/rbac')({
  component: RbacPanel,
})
